import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../../../utils/immutable";
import { IAction } from "../../../../../models/Action";

import { STATE_IDENTIFIER } from "./constants";
import { IResponseState } from "../../../../../components/Modals/ResponseModal/module/constants";
import { compose } from "redux";

const {
  REPORTS,
  REPO_DEL_STATE,
  REPO_ADD_EDIT_STATE,
  IS_EDIT,
  TO_EDIT,
  ROLES,
  REPO_ROLES,
  TO_VIEW,
  VALUE,
  GENERATION_STATE,
  GENERATED,
  LOADER_IDENTIFIER,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_REPORTS]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),

  [actionTypes.GET_REPORTS_SUCCESS]: (state: any, action: any) => {
    return compose(
      immutableSet([REPORTS], action.payload),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.GET_REPORTS_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([REPORTS], []),
      immutableSet([LOADER_IDENTIFIER], false)
    )(state),

  [actionTypes.DELETE_REPORT]: (state: any, action: any) =>
    immutableSet([REPO_DEL_STATE], IResponseState.PENDING, state),
  [actionTypes.DELETE_REPORT_SUCCESS]: (state: any, action: any) =>
    immutableSet([REPO_DEL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.DELETE_REPORT_FAILURE]: (state: any, action: any) =>
    immutableSet([REPO_DEL_STATE], IResponseState.ERROR, state),

  [actionTypes.SET_IS_EDIT]: (state: any, action: any) =>
    immutableSet([IS_EDIT], action.payload, state),

  [actionTypes.SET_TO_EDIT]: (state: any, action: any) =>
    immutableSet([TO_EDIT], action.payload, state),

  [actionTypes.SET_TO_VIEW]: (state: any, action: any) =>
    immutableSet([TO_VIEW], action.payload, state),

  [actionTypes.REPORT_VALUE]: (state: any, action: any) => {
    let TempArray = [...state.value];

    TempArray.forEach((input) => {
      if (input.id === action.payload.id) {
        input.value = action.payload.value;
      }
    });
    return compose(immutableSet([VALUE], TempArray, state));
  },

  [actionTypes.ADD_REPORT_INPUT]: (state: any, action: any) => {
    let TempArray = [...state.value];

    TempArray.push({
      value: action.payload.value,
      id: action.payload.id,
      parameter: action.payload.parameter,
      label: action.payload.label,
      property: action.payload.property,
    });
    return compose(immutableSet([VALUE], TempArray, state));
  },

  [actionTypes.POST_GENERATE]: (state: any, action: any) =>
    immutableSet([GENERATION_STATE], IResponseState.PENDING, state),
  [actionTypes.POST_GENERATE_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([GENERATION_STATE], IResponseState.SUCCESS),
      immutableSet([GENERATED], action.payload)
    )(state),
  [actionTypes.POST_GENERATE_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([GENERATION_STATE], IResponseState.ERROR),
      immutableSet([GENERATED], [])
    )(state),

  [actionTypes.GET_ROLES_SUCCESS]: (state: any, action: any) =>
    immutableSet([ROLES], action.payload, state),
  [actionTypes.GET_ROLES_FAILURE]: (state: any, action: any) =>
    immutableSet([ROLES], [], state),

  [actionTypes.GET_REPO_ROLES_SUCCESS]: (state: any, action: any) =>
    immutableSet([REPO_ROLES], action.payload, state),
  [actionTypes.GET_REPO_ROLES_FAILURE]: (state: any, action: any) =>
    immutableSet([REPO_ROLES], [], state),

  [actionTypes.POST_REPORT]: (state: any, action: any) =>
    immutableSet([REPO_ADD_EDIT_STATE], IResponseState.PENDING, state),
  [actionTypes.POST_REPORT_SUCCESS]: (state: any, action: any) =>
    immutableSet([REPO_ADD_EDIT_STATE], IResponseState.SUCCESS, state),
  [actionTypes.POST_REPORT_FAILURE]: (state: any, action: any) =>
    immutableSet([REPO_ADD_EDIT_STATE], IResponseState.ERROR, state),

  [actionTypes.PUT_REPORT]: (state: any, action: any) =>
    immutableSet([REPO_ADD_EDIT_STATE], IResponseState.PENDING, state),
  [actionTypes.PUT_REPORT_SUCCESS]: (state: any, action: any) =>
    immutableSet([REPO_ADD_EDIT_STATE], IResponseState.SUCCESS, state),
  [actionTypes.PUT_REPORT_FAILURE]: (state: any, action: any) =>
    immutableSet([REPO_ADD_EDIT_STATE], IResponseState.ERROR, state),

  [actionTypes.PUT_ROLES]: (state: any, action: any) =>
    immutableSet([REPO_ADD_EDIT_STATE], IResponseState.PENDING, state),
  [actionTypes.PUT_ROLES_SUCCESS]: (state: any, action: any) =>
    immutableSet([REPO_ADD_EDIT_STATE], IResponseState.SUCCESS, state),
  [actionTypes.PUT_ROLES_FAILURE]: (state: any, action: any) =>
    immutableSet([REPO_ADD_EDIT_STATE], IResponseState.ERROR, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin" ||
      action.payload.location.pathname ===
        "/admin-report-management/reportManagement")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
